import React from 'react';
import request from 'superagent';
import config from '../../config';

const API_URL = config.serverUrl;

export default class Login extends React.Component {

  state = {
    username: '',
    password: '',
    err: ''
  };

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown.bind(this));
  }

  onKeyDown(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  updateUsername(ev) {
    ev.stopPropagation();
    const username = ev.target.value;
    this.setState({
      username: username
    });
  }

  updatePassword(ev) {
    ev.stopPropagation();
    const password = ev.target.value;
    this.setState({
      password: password
    });
  }

  login() {
    request
      .post(`${API_URL}/login`)
      .withCredentials()
      .send(
        {
          username: this.state.username,
          password: this.state.password
        })
      .end(function (req, resp, err) {
        console.log('Logged in succesfully!');
        console.log('Request: ', req);
        console.log('Response: ', resp);
        if (err) {
          console.log('Error logging in: ', err);
        }
        else {
          window.location = '/intranet';
        }

      });
  }

  render() {

    if (this.state.err) {
      return (
        <div>
          { this.state.err }
        </div>
      );
    }

    return (
      <div className="admin-page__logincontainer">
        <div className="admin-page__login">
          <input className="form-control" type="text" placeholder="Nume de utilizator" value={ this.state.username } onChange={ this.updateUsername.bind(this) }/>
          <input className="form-control" type="password" placeholder="Parola" value={ this.state.password } onChange={ this.updatePassword.bind(this) }/>

          <button className="btn btn-info" onClick={ this.login.bind(this) }>Login</button>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/login/index.js